import { render, staticRenderFns } from "./CandidateAnswers.vue?vue&type=template&id=7ac492c4&"
import script from "./CandidateAnswers.vue?vue&type=script&lang=js&"
export * from "./CandidateAnswers.vue?vue&type=script&lang=js&"
import style0 from "./CandidateAnswers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports